import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface LogoProps {
    className?: string
    showText?: boolean
}

const LogoMark: FC<{ className?: string }> = ({ className }): ReactNode => {
    return (
        <svg viewBox='0 0 64 64' className={cn('size-8 shrink-0', className)} aria-hidden='true'>
            <defs>
                <linearGradient id='wr-logo-gradient' x1='0' y1='0' x2='1' y2='1'>
                    <stop offset='0' stopColor='#8b5cf6' />
                    <stop offset='0.55' stopColor='#3b82f6' />
                    <stop offset='1' stopColor='#22d3ee' />
                </linearGradient>
            </defs>
            <rect width='64' height='64' rx='16' fill='#0b1127' />
            <rect x='2' y='2' width='60' height='60' rx='14' fill='none' stroke='url(#wr-logo-gradient)' strokeOpacity='0.55' strokeWidth='2' />
            <rect x='14' y='16' width='24' height='24' rx='6' fill='none' stroke='url(#wr-logo-gradient)' strokeWidth='4' />
            <rect x='26' y='26' width='24' height='24' rx='6' fill='url(#wr-logo-gradient)' />
        </svg>
    )
}

const Logo: FC<LogoProps> = ({ className, showText = true }): ReactNode => {
    return (
        <span className={cn('inline-flex items-center gap-2.5', className)}>
            <LogoMark />
            {showText && (
                <span className='font-heading text-[15px] font-semibold tracking-tight text-white'>
                    WebReplica
                    <span className='ml-1 text-gradient'>AI</span>
                </span>
            )}
        </span>
    )
}

export { LogoMark }
export default Logo
